import React from 'react';
import styled from 'styled-components';

const ButtonWrapper = styled.button`
  display: inline-block;
  background-color: var(--primary-color);
  color: var(--text-color);
  padding: 12px 30px;
  border: 2px solid var(--secondary-color);
  border-radius: 4px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  
  &:hover {
    background-color: var(--secondary-color);
    color: var(--dark-color);
  }
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: 0.5s;
  }
  
  &:hover::before {
    left: 100%;
  }
  
  @media (max-width: 400px) {
    padding: 10px 20px;
    font-size: 0.9rem;
  }
`;

const Button = ({ children, onClick, type = 'button', className, disabled }) => {
  return (
    <ButtonWrapper
      type={type}
      onClick={onClick}
      className={className}
      disabled={disabled}
    >
      {children}
    </ButtonWrapper>
  );
};

export default Button;
